import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_SEND_MAIL_TO_PHYSICIAN,
  SUCCESS_SEND_MAIL_TO_PHYSICIAN,
  FAILURE_SEND_MAIL_TO_PHYSICIAN,
  LOADING_SEND_MAIL_TO_PHYSICIAN,
} = documentationActions;

function* sendMailToPhysician(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SEND_MAIL_TO_PHYSICIAN });
    const response = yield call(
      templateService.sendMailToPhysician,
      action.supervisiorUuid,
      action.payload
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_SEND_MAIL_TO_PHYSICIAN, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SEND_MAIL_TO_PHYSICIAN, payload: error });
  }
}

function* sendMailToPhysicianSaga() {
  yield takeEvery(REQUEST_SEND_MAIL_TO_PHYSICIAN, sendMailToPhysician);
}

export default sendMailToPhysicianSaga;
